import React, { Component } from 'react';

export default class Sales extends Component {

    render () {
        return (
            <div className='col-xs-12 col-md-12 col-lg-12'>
                <h4 className='text-center'>Please wait. We are working on this.</h4>
            </div>
        )
    }
}




// WEBPACK FOOTER //
// ./src/components/history/sales.js